import React from 'react';
import { Experiment, Variant } from '@svt/abtest/lib/redux';
import CookieConsent, { Variant as CookieConsentVariant } from './CookieConsent';

const CookieConsentContainer = () => (
    <Experiment
        projectId="svtplay"
        slug="cookie-consent"
        defaultVariant="original"
        timeout={5000}
        waitForVariant
    >
        <Variant slug="original">
            <CookieConsent variant={CookieConsentVariant.Original} />
        </Variant>
        <Variant slug="one-layer">
            <CookieConsent variant={CookieConsentVariant.OneLayer} />
        </Variant>
        <Variant slug="one-layer-reject-all">
            <CookieConsent variant={CookieConsentVariant.OneLayerRejectAll} />
        </Variant>
        <Variant slug="two-layers-reject-all">
            <CookieConsent variant={CookieConsentVariant.TwoLayersRejectAll} />
        </Variant>
        <Variant slug="two-layers-no-reject-all">
            <CookieConsent variant={CookieConsentVariant.TwoLayersNoRejectAll} />
        </Variant>
    </Experiment>
);

export default CookieConsentContainer;
